<template>
<div v-if="preloadDone">
  <kendo-datasource ref="datasource1" :transport="gridTransport" :schema-model-id="schemaModelId" :schema-model-fields="schemaModelFields" :schema-data="'data'" :server-paging="false" :server-filtering="false" :server-sorting="false" :aggregate="aggregateDefinition"
    :group="groupDefinition" :page="options.dataSource.page" v-on:requestend="dataSourceLoaded" v-on:error="dataSourceLoadError">
  </kendo-datasource>
  <kendo-grid ref="mygrid" :scrollable-virtual="true" v-on:detailinit="detailInit" :data-source-ref="'datasource1'" :filterable='filterable' :sortable='sortable' :columns="columns" v-on:filter-detail="queryFromDetail" :scrollable="true">
  </kendo-grid>
</div>
</template>

<script>
import Vue from 'vue'

import {
  KendoGrid,
  KendoGridInstaller
} from '@progress/kendo-grid-vue-wrapper'
import {
  KendoDataSource,
  KendoDataSourceInstaller
} from '@progress/kendo-datasource-vue-wrapper'
// var jQuery = require('jquery')
import Detail from '@/views/Sellin/Detail.vue'

Vue.use(KendoDataSourceInstaller)
Vue.use(KendoGridInstaller)

export default {
  name: 'StatisticsGrid',
  props: ['name', 'gridHeight', 'schemaModelFields', 'schemaModelId', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'query', 'details', 'aggregateDefinition', 'rows', 'groupDefinition'],
  components: {
    KendoGrid,
    KendoDataSource,
    Detail
  },
  data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    }
  },
  methods: {
    dataSourceLoaded(e) {
      this.$emit('ds-loaded', e)
    },
    dataSourceLoadError(e) {
      this.$emit('ds-error', e)
    },
    queryFromDetail() {
      console.log('hey, aquery from a detail!')
    },
    detailInit: function(e) {
      var that = this
      var ComponentClass = Vue.extend(Detail)
      var instance = new ComponentClass({
        propsData: {
          query: this.query,
          rowData: e.data,
          details: this.details,
          masterRows: this.rows
        }
      })
      instance.$mount() // pass nothing
      instance.$on('filter-detail', function(evt) {
        that.$emit('filter-detail', evt)
      })
      e.detailCell.append(instance.$el)
    },
    setQuery() {
      // router.push({ name: 'user', params: { userId }})
      this.axios.post('queries', this.query).then(response => {
        this.$router.push({
          name: 'statistics.query',
          params: {
            id: response.data.data.uuid
          }
        })
      })
    },
    getTransport() {
      var v = this
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: 'POST',
          data: this.query,
          beforeSend(req) {
            console.log(req)
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token())
          }
        }
      }
    },
    refresh() {
      this.$refs.mygrid.kendoWidget().dataSource.read()
    },
    getTotal(response) {
      return response.meta.pagination.total
    },
    setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data
        }
      }
    }
  },
  created() {
    var that = this
    var apiPreloads = []
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api)
      }
      this.axios.all(apiPreloads.map(l => this.axios.get(l))).then(
        that.axios.spread(function() {
          for (var i = 0; i < that.preload.length; i++) {
            that.setColumnsData(arguments[i].data.data, that.preload[i].field)
          }
          that.preloadDone = true
        })
      ).catch(response => {
        console.error('error loading foreigns', response)
      })
    } else {
      that.preloadDone = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// SellinGrid.vue?62aa5d1e